import React from "react";
import { Reveal, Eyebrow, BrowserFrame } from "./MarketingUI";
import { History, Users, FileStack, Gavel, ShieldCheck } from "lucide-react";

const points = [
  { icon: History, title: "Bill History", desc: "Track legislative actions and movement over time." },
  { icon: Users, title: "Sponsors & Committees", desc: "Understand the people and committees behind legislation." },
  { icon: FileStack, title: "Versions & Documents", desc: "Keep official versions and source material together." },
  { icon: Gavel, title: "Votes", desc: "Surface available official voting activity, linked to authoritative records." },
  { icon: ShieldCheck, title: "Source Provenance", desc: "Maintain traceability to official government information." },
];

export default function Intelligence() {
  return (
    <section className="bg-[#F5F7FA] py-24 sm:py-28" data-testid="intelligence-section">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="max-w-3xl">
          <Reveal><Eyebrow>Real legislative intelligence</Eyebrow></Reveal>
          <Reveal delay={0.05}>
            <h2 className="mt-4 font-display text-3xl font-extrabold leading-tight tracking-tight text-brand-ink sm:text-4xl">
              See the legislative record. Understand what changed.
            </h2>
          </Reveal>
        </div>

        <div className="mt-14 grid items-center gap-12 lg:grid-cols-[1.3fr_1fr]">
          <Reveal>
            <BrowserFrame url="app.govflowstate.com/bills/SB-28" testid="intelligence-screenshot">
              <img src="/marketing/bill-detail.png" alt="GovFlowState bill detail — legislative record, workflow status, versions, votes and source provenance" className="block w-full" loading="lazy" />
            </BrowserFrame>
            <p className="mt-3 text-xs text-brand-slate/80">Actual GovFlowState bill workspace. Florida data shown as a live implementation example.</p>
          </Reveal>

          <div className="space-y-5">
            {points.map((p, i) => (
              <Reveal key={p.title} delay={0.07 * i}>
                <div className="flex gap-4" data-testid={`intelligence-point-${i}`}>
                  <span className="grid h-11 w-11 shrink-0 place-items-center rounded-xl bg-white shadow-card ring-1 ring-brand-line">
                    <p.icon className="h-5 w-5 text-brand-teal" strokeWidth={1.9} />
                  </span>
                  <div>
                    <h3 className="font-display text-base font-bold text-brand-ink">{p.title}</h3>
                    <p className="mt-0.5 text-sm leading-snug text-brand-slate">{p.desc}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
